import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import FloatingInput from "../common/FloatingInput";

function CreateFolderModal({
  show,
  availableFolders,
  setAvailableFolders,
  handleClose,
}) {
  const [newFolder, setNewFolder] = useState("");

  const handleSave = () => {
    if (newFolder === "") {
      toast.error("Please select a folder");
    } else {
      toast.info("Creating folder...");
      setAvailableFolders([...availableFolders, newFolder]);
      handleClose();
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton className="bg-safy-info text-white">
          <Modal.Title>Create Folder</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-safy2-4">
          <FloatingInput
            label="Folder Name"
            value={newFolder}
            onChange={(e) => setNewFolder(e.target.value)}
          />
          <div className="h5 text-danger fw-bold">
            This will create a temporary folder. This folder will be removed if
            a file is not uploaded after creating!
          </div>
        </Modal.Body>
        <Modal.Footer className="bg-safy2-4">
          <div className="btn btn-sm btn-danger" onClick={handleClose}>
            Cancel
          </div>
          <div className="btn btn-sm btn-success" onClick={handleSave}>
            Save
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CreateFolderModal;
